import { jsxs as l, jsx as r } from "react/jsx-runtime";
import m from "../../../../elements/link-wrapper/link-wrapper.js";
import c from "../mobile-menu-action-bar/mobile-menu-action-bar.js";
import e from "./mobile-second-level-menu.module.less.js";
const h = ({ title: a, menuItems: s, onClickBack: n, onClickClose: o }) => /* @__PURE__ */ l("div", { className: e.wrapper, children: [
  /* @__PURE__ */ r("div", { className: e.innerWrapper, children: /* @__PURE__ */ l("div", { className: e.topItemsWrapper, children: [
    /* @__PURE__ */ r("p", { className: [e.title, "eyebrow mb-xs"].join(" "), children: a }),
    /* @__PURE__ */ r("ul", { className: e.items, children: s?.map((i, t) => /* @__PURE__ */ r("li", { className: e.item, children: /* @__PURE__ */ r(
      m,
      {
        className: [e.link, "body-l"].join(" "),
        url: i?.url,
        title: i?.title,
        onPreNavigate: i?.onPreNavigate
      }
    ) }, t)) })
  ] }) }),
  /* @__PURE__ */ r(c, { onClickClose: o, onClickBack: n })
] });
export {
  h as default
};
